import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  LIFESTYLE = 'Lifestyle',
  TRAVEL = 'Travel',
  CARS = 'Cars',
  CAREERS = 'Careers',
  WORKPLACE = 'Workplace',
  FITNESS = 'Fitness',
  RELATIONSHIPS = 'Relationships',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['lifestyle'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['lifestyle/travel'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['lifestyle/cars'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['lifestyle/relationships'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['lifestyle/careers'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['lifestyle/workplace'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['lifestyle/fitness'] } }
    ]
  }
};

const TRAVEL = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['lifestyle/travel'] } }]
  }
};

const CARS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['lifestyle/cars'] } }]
  }
};

const CAREERS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['lifestyle/careers'] } }]
  }
};

const WORKPLACE = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['lifestyle/workplace'] } }]
  }
};

const FITNESS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['lifestyle/fitness'] } }]
  }
};

const RELATIONSHIPS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['lifestyle/relationships'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: [
            'lifestyle',
            'lifestyle/travel',
            'lifestyle/cars',
            'lifestyle/relationships',
            'lifestyle/careers',
            'lifestyle/workplace',
            'lifestyle/fitness'
          ]
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'lifestyle' } }, { prefix: { key: 'DJEThing', value: 'lifestyle/' } }],
    not: []
  }
};

export { MAIN, SECTION_ENUM, TRAVEL, CARS, CAREERS, WORKPLACE, FITNESS, RELATIONSHIPS, RELATED_OPINION, VIDEO };
